import styled from 'styled-components'
import TextField from '@mui/material/TextField'

export const TextArea = styled(TextField)`
  && {
    width: 100%;
    max-width: 800px;
    margin-top: 54px;
    margin-bottom: 20px;
  }
`

export const InlineButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 800px;
  padding-right: 0;
  margin-right: 0;
  box-sizing: border-box;
`
